<button *ngIf="buttonType=='new-user' else upgradePlanBtn;" type="button" form="clientForms" class="tu-btn select-plan transparent apple-pay-button mb-2" (click)="callApplePay('new-plan')" #applePay></button>
<ng-template #upgradePlanBtn>
  <button type="button" form="clientForms" class="tu-btn select-plan apple-pay-button apple-pay-button-with-text apple-pay-button-black-with-text" (click)="callApplePay('upgrade-user')" #applePay>
    <strong>Pay with</strong>
    <img class="pl-1 mt-1" src="https://192.168.1.10:6363/images/icons/cards/apple-pay-white.svg" loading="lazy">
  </button>
</ng-template>
<!-- <button class="apple-pay-button-with-text apple-pay-button-black-with-text select-plan transparent apple-pay-button" (click)="onApplePayClick()">
  <span class="text">Pay with</span>
  <span class="logo"></span>
</button> -->

